<script setup lang="ts">

import { formatNumberFullTruncate } from '@/helpers/utils'
import CoinIcon from '@/components/icons/CoinIcon.vue'
import PlusIcon from '@/components/icons/PlusIcon.vue'
import { computed } from 'vue'
import NumberFormatTooltip from '@/components/NumberFormatTooltip.vue'
import { useGiveaway } from '@/composables/game/giveaway'

const props = defineProps<{
  reward: number
  spins?: number | undefined
  tickets?: number | undefined
}>()

const { countdown: giveawayCountdown } = useGiveaway()
const coinsReward = computed(() => formatNumberFullTruncate(props.reward))
</script>

<template>
  <div
    class="flex items-center max-[380px]:gap-x-1 gap-x-2 justify-center"
  >
    <CoinIcon class="w-5 h-auto min-w-[20px]" />
    <NumberFormatTooltip
      :number="coinsReward"
      :formatting-type="'full'"
    >
      <div
        class="text-green-primary font-bold -tracking-[0.5]"
        :class="coinsReward.length > 6 ? 'text-[20px] leading-9' : 'text-[24px] leading-[40px]'"
      >
        {{ coinsReward }}
      </div>
    </NumberFormatTooltip>
    <PlusIcon
      v-if="spins"
      class="mx-2 size-4 min-w-[16px]"
    />
    <template
      v-if="spins"
    >
      <img
        src="@/assets/images/fortune-wheel-without-border.png"
        class="size-8 min-w-[32px] object-cover"
      >
      <div
        class="text-green-primary font-bold -tracking-[0.5]"
        :class="coinsReward.length > 6 ? 'text-[20px] leading-9' : 'text-[24px] leading-[40px]'"
      >
        {{ formatNumberFullTruncate(spins) }}
      </div>
    </template>
    <PlusIcon
      v-if="giveawayCountdown && tickets"
      class="mx-2 size-4 min-w-[16px]"
    />
    <template
      v-if="giveawayCountdown && tickets"
    >
      <img
        src="@/assets/images/emojis/emoji-ticket.png"
        class="size-8 min-w-[32px] object-cover"
      >
      <div
        class="text-green-primary font-bold -tracking-[0.5] text-[24px] leading-[40px]"
      >
        {{ tickets }}
      </div>
    </template>
  </div>
</template>

<style scoped>

</style>